import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Statistic from "semantic-ui-react/dist/es/views/Statistic/Statistic.js";
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { Divider } from "../../elements/Divider";
import { ShowOn } from "../../layout/ShowOn";
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { BOOK_NOW_DISCOUNT, SAVE_UP_TO, USE_COUPON_CODE } from "../../../utils/default-strings";
import { Grid } from "../../layout/Grid";
import { GridColumn } from "../../layout/GridColumn";
import { GridRow } from "../../layout/GridRow";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { Button } from "../../elements/Button";
export var Component = function Component(_ref) {
  var backgroundImageHeight = _ref.backgroundImageHeight,
      backgroundImageSizes = _ref.backgroundImageSizes,
      backgroundImageSrcSet = _ref.backgroundImageSrcSet,
      backgroundImageUrl = _ref.backgroundImageUrl,
      backgroundImageWidth = _ref.backgroundImageWidth,
      discountAmount = _ref.discountAmount,
      discountAmountParagraphText = _ref.discountAmountParagraphText,
      discountCode = _ref.discountCode,
      discountCodeParagraphText = _ref.discountCodeParagraphText,
      discountHoverButtonText = _ref.discountHoverButtonText,
      headingText = _ref.headingText,
      onClick = _ref.onClick,
      placeholderBackgroundImage = _ref.placeholderBackgroundImage;
  return React.createElement(Segment, {
    basic: true,
    className: "is-promotion",
    onClick: onClick
  }, React.createElement(Grid, {
    className: "first-grid",
    isStackable: true,
    stretched: true
  }, React.createElement(GridRow, {
    verticalAlign: "middle"
  }, React.createElement(GridColumn, {
    className: "content-section",
    computer: 9,
    mobile: 12,
    tablet: 9
  }, !!backgroundImageUrl && React.createElement(ResponsiveImage, {
    imageHeight: backgroundImageHeight,
    imageUrl: backgroundImageUrl,
    imageWidth: backgroundImageWidth,
    placeholderImageUrl: placeholderBackgroundImage,
    sizes: backgroundImageSizes,
    srcSet: backgroundImageSrcSet
  }), React.createElement(Grid, {
    padded: true
  }, !!headingText ? React.createElement(GridRow, {
    verticalAlign: "top"
  }, React.createElement(ShowOn, {
    computer: true,
    parent: GridColumn,
    parentProps: {
      textAlign: 'left',
      width: 12
    },
    tablet: true,
    widescreen: true
  }, React.createElement(Heading, null, headingText)), React.createElement(ShowOn, {
    mobile: true,
    parent: GridColumn,
    parentProps: {
      textAlign: 'center',
      width: 12
    }
  }, React.createElement(Heading, null, headingText))) : React.createElement(Divider, {
    size: "huge"
  }), React.createElement(ShowOn, {
    computer: true,
    parent: GridRow,
    parentProps: {
      className: 'book-now-button-container'
    },
    tablet: true,
    widescreen: true
  }, React.createElement(GridColumn, {
    textAlign: "center",
    width: 12
  }, React.createElement(Button, {
    isRounded: true
  }, discountHoverButtonText))), !!discountCode && React.createElement(Fragment, null, React.createElement(ShowOn, {
    mobile: true,
    parent: GridRow,
    parentProps: {
      verticalAlign: 'top'
    }
  }, React.createElement(GridColumn, {
    floated: "right",
    textAlign: "center",
    width: 12
  }, React.createElement("div", null, React.createElement(Paragraph, {
    size: "tiny"
  }, discountCodeParagraphText), !!discountCode && React.createElement(Button, {
    hasShadow: true,
    isPositionedRight: true
  }, discountCode)))), React.createElement(ShowOn, {
    computer: true,
    desktop: true,
    parent: GridRow,
    parentProps: {
      verticalAlign: 'bottom'
    },
    tablet: true,
    widescreen: true
  }, React.createElement(GridColumn, {
    floated: "right",
    textAlign: "right",
    width: 6
  }, React.createElement("div", null, React.createElement(Paragraph, {
    size: "tiny"
  }, discountCodeParagraphText), React.createElement(Button, {
    hasShadow: true,
    isPositionedRight: true
  }, discountCode))))))), React.createElement(GridColumn, {
    className: "discount-section",
    computer: 3,
    mobile: 12,
    tablet: 3,
    textAlign: "center",
    verticalAlign: "middle"
  }, React.createElement(Statistic, {
    size: "small"
  }, React.createElement(Statistic.Label, null, React.createElement(Heading, {
    size: "small"
  }, discountAmountParagraphText)), React.createElement(Statistic.Value, null, React.createElement(Heading, {
    size: "large"
  }, discountAmount)))))));
};
Component.displayName = 'Promotion';
Component.defaultProps = {
  backgroundImageHeight: undefined,
  backgroundImageSizes: undefined,
  backgroundImageSrcSet: undefined,
  backgroundImageWidth: undefined,
  backgroundImageUrl: undefined,
  discountAmountParagraphText: SAVE_UP_TO,
  discountCode: undefined,
  discountCodeParagraphText: USE_COUPON_CODE,
  discountHoverButtonText: BOOK_NOW_DISCOUNT,
  headingText: undefined,
  placeholderBackgroundImage: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  backgroundImageHeight: PropTypes.number,
  backgroundImageSizes: PropTypes.string,
  backgroundImageSrcSet: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  backgroundImageWidth: PropTypes.number,
  discountAmount: PropTypes.string.isRequired,
  discountAmountParagraphText: PropTypes.string,
  discountCode: PropTypes.string,
  discountCodeParagraphText: PropTypes.string,
  discountHoverButtonText: PropTypes.string,
  headingText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  placeholderBackgroundImage: PropTypes.string
} : {};